export * from './emotion';
export * from './mui';
export const EMPTY_VALUE = '–';
export function displayNullable(str, allowEmpty = false) {
    return allowEmpty ? (str ?? EMPTY_VALUE) : str || EMPTY_VALUE;
}
